import { common } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";


export const dark_blue = "#08226B";
export const royal = "#f4a70f";
export const light_blue = "#0000ff";
export const red = "#d32f2f";
export const light_grey = "#d9d9d9";
export const white = "#FFFFFF"
export const red_border = "solid red 1px";
export const blue_border = "solid blue 1px";

export const noArrows = {
  "& .MuiInputBase-input": {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkitAppearance": "none",
    },
  },
};


export const listStyle = {
  fontSize: 16,
  fontFamily: "Lora, serif",
  color: dark_blue,
  marginBottom: 0,
};
export const subListStyle = {
  fontSize: 16,
  fontFamily: "Lora, serif",
  color: dark_blue,
  listStyle: "circle",
  marginLeft: 10,
  marginTop: 0,
};

export const linkStyle = {
  color: dark_blue,
  fontStyle: "italic",
  fontFamily: "Lora, serif",
  fontSize: 18,
  " @media (minWidth:400px)": { fontSize: 10 },
};
export const linkStyle1 = {
  color: dark_blue,
  fontFamily: "Lora, serif",
  fontSize: 18,
};

export const button = {
  color: dark_blue,
  backgroundColor: white,
  fontFamily: "Lora, serif",
  fontSize: 26,
  marginBottom: '2em',  
  
  width: '18em', 
  height: '10em',
  onhover: {boxShadow: 9}
  

};

const theme = createTheme({
  palette: {
    primary: {
      main: dark_blue,
    },
    secondary: {
      main: royal,
    },
    success: {
      main: red,
    },
    info: {
      main: light_grey,
    },
  },
  typography: {
    fontFamily: "Lora, serif",
    body1: {
      fontSize: 17,
      "@media (minWidth:280px)": {
        fontSize: 12,
        lineHeight: 1.1,
        fontWeight: "bold",
      },

      "@media (minWidth:400px)": {
        fontSize: 13,
        fontWeight: "bold",
      },
      "@media (minWidth:600px)": {
        fontSize: 16,
      },
      "@media (minWidth:800px)": {
        fontSize: 18,
      },
      "@media (minWidth:1000px)": {
        fontSize: 15,
      },
      "@media (minWidth:1280px)": {
        fontSize: 15,
      },
    },
    h6: {
      "@media (minWidth:280px)": {
        fontSize: 15,
        fontWeight: "bold",
      },

      "@media (minWidth:400px)": {
        fontSize: 16,
        fontWeight: "bold",
      },
      "@media (minWidth:600px)": {
        fontSize: 22,
      },
      "@media (minWidth:800px)": {
        fontSize: 24,
      },
      "@media (minWidth:1000px)": {
        fontSize: 20,
      },
      "@media (minWidth:1280px)": {
        fontSize: 20,
      },
    },
    h2: {
      "@media (minWidth:280px)": {
        fontSize: 26,
        fontWeight: "bold",
      },

      "@media (minWidth:400px)": {
        fontSize: 30,
        fontWeight: "bold",
      },
      "@media (minWidth:600px)": {
        fontSize: 34,
      },
      "@media (minWidth:800px)": {
        fontSize: 36,
      },
      "@media (minWidth:1000px)": {
        fontSize: 38,
      },
      "@media (minWidth:1280px)": {
        fontSize: 44,
      },
    },
  },

  components: {

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: 17,
          error: red,
          textAlign: "left",
          alignItems: "left"
        },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          width: "100%",
          alignItems: "center",
          marginTop: 16,
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: { textAlign: "center", color: dark_blue },
      },
    },

    MuiCardHeader: {
      styleOverrides: {
        root: {
          backgroundColor: "#F0F0F0",
          borderBottom: "1px solid lightgrey",
          textAlign: "center",
        },
        content: { maxWidth: "100%" },
      },
      defaultProps: {
        titleTypographyProps: {
          sx: { maxWidth: "100%" },
          variant: "h3",
        },

        subheaderTypographyProps: {
          sx: { maxWidth: "100%", marginTop: "16px" },
          variant: "h6",
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          color: dark_blue,
          fontSize: 18,
        },
      },
    },

    MuiTypography: {
      defaultProps: {
        color: common.black,
        textAlign: "center",
      },
      styleOverrides: {
        h3: {
          color: "white",
        },
        h4: {
          color: "#08226B",
        },
        h5: {
          color: "#08226B",
        },
        h6: {
          color: "#08226B",
        },
        root: {
          color: "#08226B",
        },
        caption: {
          fontSize: 18,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: "bold",
          fontSize: 18,
          listStyleType: "circle",
          listStyle: "outside",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: dark_blue,
          color: "white",
          "&:hover": {
            backgroundColor: "white",
            color: royal,
            boxShadow: 9
          },
          "&.Mui-disabled": {
            backgroundColor: light_grey,
            color: "white",
          },
        },
        contained: {
          backgroundColor: dark_blue,
        
          "&:hover": {
            backgroundColor: royal,
            color: dark_blue,
            border: 'none',
            boxShadow: 9
          },
        },
        text: {
          color: dark_blue,
          backgroundColor: white,
          fontFamily: "Lora, serif",
          fontSize: 26,
          marginBottom: '2em',  
          
        
          "&:hover": {
            color: dark_blue,
            backgroundColor: white,
            boxShadow:9
          },
        },
      },
    },
MuiPaper:{
  styleOverrides:{
    root:{
      "&:hover": {
    
        boxShadow: 20
      },
    }
  }
},
    MuiListItem: {
      styleOverrides: {
        root: { fontFamily: "Lora, serif", color: dark_blue },
      },
    },
    MuiList: {
      styleOverrides: {
        root: { fontFamily: "Lora, serif", color: dark_blue, listStyleType: "circle", listStyle: "outside" },
      },
    },


    MuiLink: {
      styleOverrides: {
        root: {
          fontStyle: "italic",
        },
      },
    },
  },
});




export default theme;



